import { render, staticRenderFns } from "./StudentHomePage.vue?vue&type=template&id=99f49e14&scoped=true"
import script from "./StudentHomePage.vue?vue&type=script&lang=js"
export * from "./StudentHomePage.vue?vue&type=script&lang=js"
import style0 from "./StudentHomePage.vue?vue&type=style&index=0&id=99f49e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f49e14",
  null
  
)

export default component.exports